export const FINANCIAL_INSIGHTS_LABEL = 'Financial Insights'
export const FINANCIAL_INSIGHTS_TOOLTIP =
  'Enable Financial Insights powered by CreditSense. Renters can verify their financial position by securely connecting their bank account.'
